import { render, staticRenderFns } from "./TransitionControl.vue?vue&type=template&id=8bb6b1c0&scoped=true&"
import script from "./TransitionControl.vue?vue&type=script&lang=js&"
export * from "./TransitionControl.vue?vue&type=script&lang=js&"
import style0 from "./TransitionControl.vue?vue&type=style&index=0&id=8bb6b1c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb6b1c0",
  null
  
)

export default component.exports